<template>
    <AxSelect v-bind="props" :options="userOptions" :emptyFilterMessage="$t('common.no_results')">
        <template #option="{ option }">
            <div class="flex w-full items-center justify-between">
                <span>
                    {{ option.label }}
                </span>
                <span class="text-gray-600">
                    {{ option.company }}
                </span>
            </div>
        </template>
        <template #value="{ value }">
            <div v-if="value && getSelectedUser(value)" class="flex items-center justify-between">
                <span>
                    {{ getSelectedUser(value)?.label }}
                </span>
                <span class="text-gray-600">
                    {{ getSelectedUser(value)?.company }}
                </span>
            </div>
        </template>
    </AxSelect>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { AxSelect } from '@axxone-system/hades';
import type { AxSelectProps, Option } from '@axxone-system/hades';

export interface AxSelectUsersProps extends /* @vue-ignore */ Omit<AxSelectProps, 'options' | 'optionValue'> {
    users: { name: string; id: number; actorId?: number; company: string | null }[];
    optionValue: string;
}

const props = defineProps<AxSelectUsersProps>();

const userOptions = computed(() => {
    return props.users.map((user) => ({
        id: user.id!,
        actorId: user.actorId ?? undefined,
        label: user.name,
        company: user.company,
    })) as Option[];
});

const getSelectedUser = (value: Option | keyof Option) => {
    if (!props.users) {
        return null;
    }

    if (value && typeof value === 'object') {
        return userOptions.value.find((user) => user.id === value.id);
    }
    return userOptions.value.find((user) => user[props.optionValue] === value);
};
</script>
